import { QueryClientProvider } from '@tanstack/react-query';
import { useState, type ReactNode } from 'react';

import { createQueryClient } from '@/lib/query-client';

import { AppErrorFallback } from './AppErrorFallback';
import { AuthProvider } from './AuthProvider';
import { ChromeSync } from './ChromeSync';
import { ConfigProvider } from './ConfigProvider';
import { ErrorBoundary } from './ErrorBoundary';

/** Composes all app-wide providers in one place. */
export function AppProviders({ children }: { children: ReactNode }): JSX.Element {
  const [queryClient] = useState(createQueryClient);

  return (
    <ErrorBoundary fallback={<AppErrorFallback />}>
      <QueryClientProvider client={queryClient}>
        <ConfigProvider>
          <AuthProvider>
            <ChromeSync />
            {children}
          </AuthProvider>
        </ConfigProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}
